export default __webpack_public_path__ + "static/media/female-logo.d275f881.svg";